<template>
    <div class="ui-content dashboard user-section user-height">
        <v-card class="mx-auto normal-card autohg">
            <div class="data-table-section" ref="infoBox">
                <v-data-table
                    :headers="headers"
                    fixed-header
                    :items="items"
                    hide-default-header
                    hide-default-footer
                    class="elevation-2 cust-table"
                >
                    <template v-slot:header="{ props: { headers } }">
                        <TableHeader
                            :headers="headers"
                            :onHeaderAction="onHeaderAction"
                            :orderBy="orderBy"
                            :onSortChange="onSortChange"
                        />
                    </template>

                    <template v-slot:body="{ items }">
                        <tbody>
                            <tr v-for="(item, idx) in items" :key="idx">
                                <td class="parent-150">{{ item.name }}</td>
                                <td>{{ item.email }}</td>
                                <td class="parent-150">{{ item.related_user_name }}</td>
                                <td>{{ item.related_user_email }}</td>
                                <td class="text-center">
                                    {{ item.center_name }}
                                </td>
                                <td class="text-center">
                                    {{ item.batch_name }}
                                </td>
                                <td class="width-180">
                                    <div class="switch-cust">
                                        <v-switch
                                            v-model="item.active"
                                            inset
                                        ></v-switch>
                                    </div>
                                </td>
                                <td class="blank-80">
                                    <v-tooltip
                                        v-if="active === 1"
                                        left
                                        content-class="cust-tooltip"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-icon
                                                class="pencil-icon"
                                                v-on="on"
                                                @click="editParentDialog(item)"
                                                >mdi-pencil</v-icon
                                            >
                                        </template>
                                        <span>Edit Name/Email ID</span>
                                    </v-tooltip>
                                    <!-- this worked   -->
                                    <v-tooltip
                                        v-else
                                        left
                                        content-class="cust-tooltip"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-icon
                                                class="delete-icon"
                                                v-on="on"
                                                @click="onDelete(item)"
                                                >mdi-delete</v-icon
                                            >
                                        </template>
                                        <span>Delete Parent</span>
                                    </v-tooltip>
                                </td>

                                <td class="text-left">
                                    <div @click="resetPassword(item)">
                                        <v-icon
                                            title="Reset Password"
                                            class="cp3-reset-pass reset-student-password"
                                            >mdi-lock-reset</v-icon
                                        >
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </template>
                </v-data-table>
            </div>
        </v-card>
        <div class="footer-btn">
            <div class="pull-left">
                <v-btn
                    @click="toggleUserStatus"
                    class="right-btn cust-btn"
                    color="primary"
                    >{{
                        active === 1 ? "Deactivated Parents" : "Active Parents"
                    }}</v-btn
                >
            </div>
            <div class="pull-right">
                <Pagination
                    :currentPage="currentPage"
                    :totalPage="totalPages"
                    :onPageChange="onPageChange"
                />
            </div>
        </div>
        <AlertBox
            :width="modalwidth"
            :onClose="onClose"
            :component="cComponent"
            :status="status"
            :data="alertBoxData"
        />
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "ManageUsersStudent",
    props: ["updateRouteDetails","search"],
    data() {
        return {
            alertBoxData: null,
            status: false,
            cComponent: "",
            modalwidth: "50%",
            batches: [],
            centers: [],
            selectedCenterId: null,
            selectedBatch: null,
            loading: false,
            status: false,
            orderBy: {
                field: "name",
                order: "ASC",
            },
            items: [],
            oldData: [],
            selctedUserForEdit: null,
            currentPage: 1,
            pageSize: 10,
            totalPages: 1,
            active: 1,
            isLoadingFirstTime: true,
        };
    },
    methods: {
        ...mapActions({
            getCenters: "centerAndBatchStore/getCentersByUser",
            getBatches: "centerAndBatchStore/getBatches",
            getSelfSignedUpUsers: "userStore/getSelfSignedUpUsers",
            setUserActiveStatus: "userStore/setUserActiveStatus",
            deleteUser: "userStore/deleteUser",
        }),
        toggleUserStatus() {
            this.currentPage = 1;
            this.pageSize = 10;
            this.active = this.active === 1 ? 0 : 1;
            this.resetCenterBatches();
            this.updateRouteDetails({
                type: "activateStatus",
                data: { active: this.active, page: 1 },
            });
            this.requesGetSelfSignedUpUsers();
        },
        resetCenterBatches() {
            this.selectedBatch = [];
            this.selectedCenterId = [];
            this.batches = this.batches.map((x) => {
                x.checked = false;
                return x;
            });
            this.centers = this.centers.map((x) => {
                x.checked = false;
                return x;
            });
        },
        onCenterSelect(centerIds) {
            if (centerIds && centerIds.length) {
                if (!this.isLoadingFirstTime) this.resetPage();
                this.updateRouteDetails({
                    type: "centerIds",
                    data: { centerIds },
                });
                this.$root.showLoader = true;
                this.getBatches({ center_id: centerIds })
                    .then((response) => {
                        // this.$root.showLoader = false;

                        if (response && response.list && response.list.length) {
                            if (this.selectedBatch) {
                                let arr = [];
                                this.selectedBatch.map((xx, i) => {
                                    let isExist = false;
                                    response.list.map((x) => {
                                        if (!isExist) {
                                            isExist = xx === x.id;
                                        }
                                    });
                                    if (!isExist) {
                                        arr.push(xx);
                                    }
                                });
                                if (arr && arr.length) {
                                    arr.map((xx) => {
                                        this.selectedBatch.splice(
                                            this.selectedBatch.indexOf(xx),
                                            1
                                        );
                                    });
                                }
                            }

                            this.batches = response.list.map((x) => {
                                let c = {};
                                c.text = x.name;
                                c.value = x.id;
                                c.checked =
                                    this.selectedBatch &&
                                    this.selectedBatch.indexOf(x.id) !== -1;
                                return c;
                            });
                        } else {
                            this.batches = [];
                        }
                    })
                    .catch((err) => {
                        this.$root.showLoader = false;
                    });
            } else {
                this.batches = [];
            }
        },
        requestGetCenters() {
            this.$root.showLoader = true;
            this.getCenters()
                .then((response) => {
                    this.centers = response.map((x) => {
                        let c = {};
                        c.text = x.name;
                        c.value = x.id;
                        c.checked = this.selectedCenterId.includes(x.id);
                        return c;
                    });
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        requesGetSelfSignedUpUsers() {
            let reqData = {
                orderBy: this.orderBy,
                role_id: this.roleIds.PA,
                is_approved: 1,
                active: this.active,
				searchQuery: this.search,
                pagination: { page: this.currentPage, pageSize: this.pageSize },
            };
            if (
                this.selectedBatch &&
                this.selectedBatch.length > 0 &&
                this.batches.length != this.selectedBatch.length
            ) {
                reqData.batch_ids = this.selectedBatch;
            }
            if (
                this.selectedCenterId &&
                this.selectedCenterId.length > 0 &&
                this.centers.length != this.selectedCenterId.length
            ) {
                reqData.center_ids = this.selectedCenterId;
            }
            this.$root.showLoader = true;
            this.getSelfSignedUpUsers(reqData)
                .then((response) => {
                    this.isLoadedFirstTime = false;
                    if (
                        response.list.length == 0 &&
                        this.currentPage != 1 &&
                        !this.$route.query.resetPage
                    ) {
                        this.onPageChange(1);
                        return;
                    }

                    this.items = response.list.map((u) => {
                        u.checked = false;
                        return u;
                    });
                    this.setOldData(this.items);
                    this.totalPages = response.pagination.pageCount;
                    this.$root.showLoader = false;
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        onHeaderAction(e) {
            if (e.header && e.header.type === "check") {
                if (e.data) {
                    this.items = this.items.map((u) => {
                        u.checked = e.data.checked;
                        return u;
                    });
                }
            } else if (
                e.header &&
                e.header.type === "multidropdown" &&
                e.header.value === "batch_name"
            ) {
                this.selectedBatch = e.data.selectedItems;
            } else if (
                e.header &&
                e.header.type === "multidropdown" &&
                e.header.value === "center_name"
            ) {
                this.selectedCenterId = e.data.selectedItems;
            } else if (e.header && e.header.type === "button") {
                if (this.items && this.items.length) {
                    let allUsers = this.items.map((u) => {
                        return u.id;
                    });
                    this.requestUpdateUserActiveStatus(
                        allUsers,
                        this.active === 1 ? false : true
                    );
                }
            }
        },
        onSortChange() {
            this.requesGetSelfSignedUpUsers();
        },
        onPageChange(e) {
            this.currentPage = e;
            this.requesGetSelfSignedUpUsers();
        },
        requestUpdateUserActiveStatus(user_ids, status, index) {
            let reqData = {
                user_ids: user_ids,
                active: status,
            };
            this.$root.showLoader = false;
            this.setUserActiveStatus(reqData)
                .then((response) => {
                    this.$root.showLoader = false;
                    if (index || index === 0) {
                        this.items.splice(index, 1);
                    } else {
                        this.items = [];
                    }

                    this.setOldData(this.items);
                })
                .catch((err) => {
                    this.$root.showLoader = false;
                });
        },
        setOldData(data) {
            this.oldData = _.cloneDeep(data);
        },
        defaultData() {
            let routeName = this.$route.name;
            let crd = this.getCurrentRouteDetails(routeName);
            if (crd) {
                this.currentPage = crd.tabDetails[crd.selectedTab].page;
                this.orderBy = crd.tabDetails[crd.selectedTab].orderBy;
                this.active = crd.tabDetails[crd.selectedTab].showActivated;
                this.selectedCenterId =
                    crd.tabDetails[crd.selectedTab].centerIds; // load center ids from session
                this.selectedBatch = crd.tabDetails[crd.selectedTab].batchIds; // load batches in session
            }
            this.requestGetCenters();
            if (!crd && !crd.tabDetails[crd.selectedTab].centerIds) {
                this.requesGetSelfSignedUpUsers();
            }
        },
        resetPassword(item) {
            this.cComponent = "components/coordinator/ResetStudentPassword";
            this.modalwidth = "400px";
            this.status = true;
            item.persistent = false;
            this.alertBoxData = item;
        },
        onClose(data) {
            this.status = data.status;
            if (data.reload) {
                this.requesGetSelfSignedUpUsers();
            }
			if (data.is_delete) {
                this.onDeleteParent(this.selctedUserForEdit);
            }
        },
        editParentDialog(user) {
            this.selctedUserForEdit = user;
            this.cComponent =
                "components/coordinator/users/EditUsers/EditParent";
            this.alertBoxData = user;
            this.status = true;
            this.modalwidth = "450px";
        },
		 onDelete(item) {
            this.cComponent =
                "components/coordinator/users/ManageUsers/ConfirmationDialog";
            this.selctedUserForEdit = item;
            this.status = true;
            this.modalwidth  = '450px'
        },
        onDeleteParent(user) {
            if (user) {
                const reqData = {
                    user_id: [user.id],
                };
                this.deleteUser(reqData)
                    .then((response) => {
                        this.$toasted.success(`Parent Deleted Successfully`, {
                            icon: "check_circle",
                        });
                        this.requesGetSelfSignedUpUsers();
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
    },
    mounted() {
        this.defaultData();
    },
    computed: {
        headers() {
            return [
                { text: "Parent Name", value: "name",class: "parent-150", },
                { text: "Parent Email ID", value: "email" },
                { text: "Student Name", value: "related_user_name",class: "parent-150", },
                { text: "Student Email ID", value: "related_user_email" },
                {
                    text: "Center",
                    value: "center_name",
                    type: "multidropdown",
                    options: this.centers,
                    class: "text-center",
                    allText: "All Centers",
                },
                {
                    text: "Batch",
                    value: "batch_name",
                    type: "multidropdown",
                    options: this.batches,
                    class: "text-center",
                    allText: "All Batches",
                },
                {
                    text: this.active === 1 ? "Deactivate all" : "Activate all",
                    value: "",
                    type: "button",
                    class: "width-180",
                },
                { text: '', value: '', type: 'blank', class: '' },
                { text: '', value: '', type: 'blank', class: '' },
            ];
        },
    },
    watch: {
        selectedCenterId(val) {
            if (val) {
                this.onCenterSelect(val);
                this.requesGetSelfSignedUpUsers();
            }
        },
        resetPage() {
            this.currentPage = 1;
            this.updateCurrentPageInSession(1);
        },
        selectedBatch(val) {
            if (!this.isLoadingFirstTime) this.resetPage();
            this.updateRouteDetails({
                type: "batchIds",
                data: { batchIds: val },
            });
            if (val && val.length) {          
                this.requesGetSelfSignedUpUsers();
            }
        },
        search() {
            this.requesGetSelfSignedUpUsers();
        },
        items: {
            deep: true,
            handler(after, before) {
                let changedItem, index;
                after.map((p, idx) => {
                    if (p["active"] !== this.oldData[idx]["active"]) {
                        changedItem = p;
                        index = idx;
                    }
                });
                this.setOldData(after);

                if (changedItem) {
                    this.requestUpdateUserActiveStatus(
                        [changedItem.id],
                        changedItem.active ? true : false,
                        index
                    );
                }
            },
        },
    },
};
</script>
